export class DateUtil {
  static toYYYYMMDDFormat = (dateTime) =>
    `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(dateTime.getDate()).padStart(2, "0")}`;
}
